import React, { useState } from "react";
import withRouter from "../../../Components/Common/withRouter";
import * as Yup from "yup";
import { useFormik } from "formik";
import { useMutation } from "react-query";
import { authUser } from "../services/authApi";
import "../../../assets/login_page_assets/css/login.css";
import fleetFix from "../../../assets/login_page_assets/images/FleetFixLogoBlack.png";
import lineConnexion from "../../../assets/login_page_assets/images/lineConnexion.png";
import loginImage from "../../../assets/login_page_assets/images/login.jpg";
import { Button, Form, FormFeedback, Input, Label, Spinner } from "reactstrap";
import "react-toastify/dist/ReactToastify.css";  
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import "../utils/style.css";
const Login = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  document.title = `Connexion | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
  const [error, setError] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);

  const { isLoading, mutate } = useMutation(authUser, {
    onSuccess: (data) => {
      if (data?.isAuthorized) {
        props.router.navigate("/dashboard");
        toast.success('Bienvenue Admin dans Fleet Fix 😊')
      } else {
        setError(t("login.invalidCredentials"));
        sessionStorage.clear();
        toast.error(t("login.errorMessage"), {
          position: "top-right",  
          autoClose: 5000,  
        });
      }
    },
    onError: (error) => {
      setError(error.message || t("login.genericError"));
      toast.error(t("login.genericError"), {
        position: "top-right",  
        autoClose: 5000,  
      });
    },
  });

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required(t("login.usernameError")),
      password: Yup.string().required(t("login.passwordError")),
    }),
    onSubmit: (values) => {
      const { username, password } = validation.values;
      const formData = {
        username: username,
        password: password,
        grant_type: process.env.REACT_APP_GRANT_TYPE,
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
      };
      mutate(formData);
    },
  });
  return (
    <div>
      <div className="container-login">
        <div className="login-image">
          <img src={loginImage} alt="Background" className="background-img" />
        </div>
        <div className="login-card" style={{ borderRadius: "30px", marginTop: "-50px",maxWidth:'550px',height:'auto'}}>
          <div className="login-form" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
            <h3 className="h3">
              <div className="check-text-container">
                <img src={fleetFix}style={{width:'166px',height:'28px',top:'121px',left:'667px'}} alt="Check" className="login-icon" />
                <span  style={{ fontSize: "29px",fontWeight: "700px", color: "#252525",fontFamily:"Raleway",marginTop:'50px'}}>{t("login.texte")}</span>
                <span  style={{ fontSize: "15px",fontWeight: "400px", color: "#5D5D5D",  fontFamily: "Inter",marginTop:'30px'}}>Gardez un œil sur chaque véhicule, optimisez les itinéraires et</span>
                <span style={{ fontSize: "15px",fontWeight: "400px", color: "#5D5D5D",fontFamily:"Inter"}}>réduisez vos coûts d’exploitation.</span>
              </div>
            </h3>
            <div className="separator-container">
              <div className="separator-line" ></div>
              <span className="separator-text"style={{ fontSize: "20px",fontWeight: "500px", color: "#252525",fontFamily:'Raleway'}}>{t("lockScreen.loginLink")}</span>
              <div className="separator-line"></div>
            </div>
            {error && <div className="alert alert-danger">{error}</div>}
            <Form onSubmit={validation.handleSubmit} style={{ flex: 1 }}>
              <div className="mb-4" style={{marginTop:'-15px'}}>
                <div className="mb-3" style={{marginLeft:'20px',marginRight:'20px'}}>
                  <Input
                  style={{fontFamily:'Lato',fontWeight:'400px',fontSize:'15px',margin:'0 auto',borderColor:'#CDCDCD',
                    borderWidth: validation.touched.username && validation.errors.username ? '1px' : '1px', 

                  }}
                    name="username"
                    id="username"
                    className="form-control pe-5"
                    placeholder={t("login.usernamePlaceholder")}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.username}
                    invalid={validation.touched.username && validation.errors.username}
                  />
                  <FormFeedback>{validation.errors.username}</FormFeedback>
                </div>
              </div>
              <div className="mb-3" style={{marginLeft:'20px',marginRight:'20px',marginTop: '25px' }}>
                <div className="position-relative auth-pass-inputgroup mb-3">
                  <Input
                      style={{fontFamily:'Lato',fontWeight:'400px',fontSize:'15px',margin:'0 auto',borderColor:'#CDCDCD',
                        borderWidth: validation.touched.password && validation.errors.password ? '1px' : '1px', // Bordure fine (1px)
              
                      }}
                    autoComplete="on"
                    name="password"
                    id="password-input"
                    value={validation.values.password || ""}
                    type={passwordShow ? "text" : "password"}
                    className="form-control pe-5"
                    placeholder={t("login.passwordPlaceholder")}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    invalid={!!(validation.touched.password && validation.errors.password)}
                  />
                  {validation.touched.password && validation.errors.password ? (
                    <FormFeedback type="invalid">
                      {validation.errors.password}
                    </FormFeedback>
                  ) : null}
                  <button
                    className="btn btn-link position-absolute end-0 top-50 translate-middle-y text-decoration-none text-muted"
                    type="button"
                    id="password-addon"
                    onClick={() => setPasswordShow(!passwordShow)}
                    style={{
                      background: "transparent",
                      border: "none",
                      right: "10px",
                      padding: 10,
                    }}
                  >
                    <i className="ri-eye-fill align-middle fs-15"></i>
                  </button>
                </div>
              </div>
              <div style={{marginLeft:'20px',marginRight:'20px'}}>
                 <a
                  href="/mot-de-passe-oublie"
                  style={{ fontSize: "15px",fontWeight: "400px", color: "#E97D00",fontFamily:'Gelix', textDecoration: "underline" }}>
                <span   style={{ fontSize: "15px",fontWeight: "400px", color: "#E97D00",fontFamily:'Gelix'}}>{t("login.forgotPassword")} </span>
                </a>
                
              </div>
          
            <div style={{ marginTop: "40px", marginBottom: "20px",marginLeft:'20px',marginRight:'20px'}}>
              <Button
                style={{ backgroundColor: "#000000", color: "white", fontFamily:'Gelix',fontWeight:'500px',fontSize:'17px'}}
                disabled={!(validation.isValid && validation.dirty)}
                type="submit"
                className="form-control btn btn-soft-success pe-5 login-fc"
              >
                {isLoading ? <Spinner size="sm" /> : t("login.loginButton")}
              </Button>
            </div>
            </Form>
          </div>
        </div>
      </div>
  </div>
  );
};

export default withRouter(Login);
